import './App.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Home, About, Recipes, RecipeDetail, Reserve } from './pages';

function App() {
  return (
    <Router>
      <Switch>
        {/* Home Page */}
        <Route path="/" exact component={Home} />
        <Route path="/about" exact component={About} />

        <Route path="/recipes" exact component={Recipes} />

        <Route path="/recipes/:recipeId" component={RecipeDetail} />

        {/* Redirect Unknown Routes to Home */}
        <Redirect to="/" />
      </Switch>
    </Router>
  );
}

export default App;
